/** @format */

import * as ActionType from "./condition.type";

const initialState = {
	condition: [],
};

export const conditionReducer = (state = initialState, action) => {
	switch (action.type) {
		case ActionType.GET_CONDITION:
			return {
				...state,
				condition: action.payload,
			};

		case ActionType.CREATE_CONDITION: {
			const data = [...state.condition, action.payload];
			return {
				...state,
				condition: data,
			};
		}

		case ActionType.DELETE_CONDITION:
			return {
				...state,
				condition: state.condition.filter((d) => d._id !== action.payload),
			};

		case ActionType.UPDATE_CONDITION:
			return {
				...state,
				condition: state.condition.map((d) => (d._id === action.payload._id ? action.payload : d)),
			};

		default:
			return state;
	}
};
